import React from 'react';
import { useNavigate } from 'react-router-dom';

interface Customer {
  Name?: string;
  Reason?: string;
}

interface CustomerAttentionCardProps {
  customer: Customer | string;
}

const CustomerAttentionCard: React.FC<CustomerAttentionCardProps> = ({ customer }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    const customerName = typeof customer === 'string' ? customer : customer.Name;
    if (customerName) {
      // Navigate to SupportCustomers page with preselected customer
      navigate('/support/customers', {
        state: { selectedCustomer: customerName }
      });
    }
  };

  const isClickable = typeof customer === 'string' || (typeof customer === 'object' && customer.Name);

  return (
    <li 
      style={{ 
        marginBottom: '0.75rem', 
        padding: '0.75rem',
        borderBottom: '1px solid #f7fafc',
        color: '#2d3748',
        lineHeight: '1.5',
        background: '#fff5f5',
        borderRadius: '6px',
        cursor: isClickable ? 'pointer' : 'default',
        transition: 'background-color 0.2s ease',
      }}
      onClick={handleClick}
      onMouseEnter={(e) => {
        if (isClickable) {
          e.currentTarget.style.backgroundColor = '#fed7d7';
        }
      }}
      onMouseLeave={(e) => {
        if (isClickable) {
          e.currentTarget.style.backgroundColor = '#fff5f5';
        }
      }}
    >
      <div style={{ fontWeight: '600', color: '#1a202c', marginBottom: '0.25rem' }}>
        {typeof customer === 'string' ? customer : customer.Name}
      </div>
      {typeof customer === 'object' && customer.Reason && (
        <div style={{ fontSize: '0.9rem', color: '#4a5568' }}>
          Reason: {customer.Reason}
        </div>
      )}
    </li>
  );
};

export default CustomerAttentionCard;
